<template lang="pug">
div(v-if="$store.state.user.auth.schedule").lime
	v-layout(justify-center align-center).mb-3.py-3
		v-progress-circular(:size="150" :width="20" color="white" :value="(3000-today.substr(8,2)*100)/30").display-1 {{today.substr(0,4)}}
		v-progress-circular(:size="150" :width="20" color="white" :value="today.substr(5,2)*100/12").display-1.ml--2 {{today.substr(5,2)}}
		v-progress-circular(:size="150" :width="20" color="white" :value="today.substr(8,2)*100/30").display-1.ml--2 {{today.substr(8,2)}}
	v-calendar(ref="calendar" v-model="today" type="month" 
			locale="zh-cn" color="blue").vh50.lime.lighten-4
		template(v-slot:day="{date}")
			template(v-for="e in eventsMap[date]")
				v-menu(v-model="e.open" full-width 
						offset-x :close-on-content-click="false")
					template(v-slot:activator="{on}")
						.my-event.lime.darken-4(v-if="!e.time" v-ripple v-on="on") {{e.title}}
					v-card(text min-width="350px")
						v-toolbar(dark).green
							v-toolbar-title {{e.title}}
							v-spacer
							v-app-bar-nav-icon(@click="set_event(e._id)")
								v-icon mdi-pencil
							v-app-bar-nav-icon(@click="remove_event(e._id)")
								v-icon mdi-delete
						v-card(flat).pa-3
							.subheading 起始時間：{{e.fromTime}}
							.subheading 結束時間：{{e.toTime}}
							.subheading 地點：{{e.place}}
							.subheading 人員：{{e.member}}
							.subheading 細節：{{e.details}}
	
	v-dialog(v-model="dialog" persistent width="600")
		v-card.pa-2(dark)
			v-text-field(text label="標題" v-model="event.title")
			v-row(no-gutters)
				v-col
					v-menu(v-model="date_menu" :close-on-content-click="false")
						template(v-slot:activator="{on,attrs}")
							v-text-field(v-bind="attrs" v-on="on" placeholder="日期" :value="event.date")
						.d-flex.flex-column
							v-date-picker(color="blue" locale="zh-cn" v-model="event.date")
							v-btn.blue(dark @click="date_menu=false") 確認
				v-col
					v-menu(v-model="fromTime_menu" :close-on-content-click="false")
						template(v-slot:activator="{on,attrs}")
							v-text-field(v-bind="attrs" v-on="on" placeholder="起始時間" :value="event.fromTime")
						.d-flex.flex-column
							v-time-picker(v-model="event.fromTime")
							v-btn(dark block @click="fromTime_menu=false").ma-0.blue 確認
				v-col
					v-menu(v-model="toTime_menu" :close-on-content-click="false")
						template(v-slot:activator="{on,attrs}")
							v-text-field(v-bind="attrs" v-on="on" placeholder="迄止時間" :value="event.toTime")
						.d-flex.flex-column
							v-time-picker(v-model="event.toTime")
							v-btn(dark block @click="toTime_menu=false").ma-0.blue 確認
			v-text-field(label="地點" v-model="event.place")
			v-text-field(label="參與人員" v-model="event.member")
			v-textarea(label="說明" v-model="event.details")
			v-layout
				v-spacer
				v-btn.ma-1(v-if="editing" @click="update_event()") 確認
				v-btn.ma-1(v-else @click="save_event()") 儲存
				v-btn.ma-1(@click="dialog=false") 返回
	v-layout.psf
		v-btn.ma-1(fab dark @click="$refs.calendar.prev()").red
			v-icon mdi-arrow-left-thick
		v-btn.ma-1(fab dark @click="add_event()")
			v-icon mdi-plus
		v-btn.ma-1(fab dark @click="$refs.calendar.next()").red
			v-icon mdi-arrow-right-thick
</template>

<script>
import { addDoc, collection, deleteDoc, doc, getDocs, setDoc } from '@firebase/firestore';
import { db, shot2docs } from '../main';

export default {
    name: 'schedule',
    data() {
        return {
            dialog: false,
            today: '',
            date_menu: false,
            fromTime_menu: false,
            toTime_menu: false,
            editing: false,
            event: {},
            events: [
                //{_id:0,title:'會談',details:'談話',date:'2019-04-20',place:'',member:'',fromTime:'',toTime:'',open:false},
            ],
        };
    },
    methods: {
        set_event(_id) {
            this.event = this.events.filter((x) => x._id == _id)[0];
            this.editing = true;
            this.dialog = true;
        },
        update_event() {
            setDoc(doc(db, 'schedule', this.event._id), this.event).then(() => {
                this.events.filter((x) => x._id == this.event._id)[0] = this.event;
                this.dialog = false;
            });
        },
        add_event() {
            (this.event = { title: '', details: '', date: '', place: '', member: '', fromTime: '', toTime: '', open: false }), (this.dialog = true);
            this.editing = false;
        },
        save_event() {
            if (this.event.title == '') {
                this.event.title = '我的超猛標題';
            }
            if (this.event.date != '') {
                addDoc(collection(db, 'schedule'), this.event).then((res) => {
                    this.event._id = res.id;
                    this.events.push(this.event);
                    this.dialog = false;
                });
            }
        },
        remove_event(_id) {
            deleteDoc(doc(db, 'schedule', _id)).then(() => {
                this.events = this.events.filter((x) => x._id != _id);
            });
        },
    },
    computed: {
        eventsMap() {
            const map = {};
            this.events.forEach((e) => (map[e.date] = map[e.date] || []).push(e));
            return map;
        },
    },
    mounted() {
        var date = new Date();
        this.today = date.toISOString().slice(0, 10);
        getDocs(doc(db, 'schedule')).then((res) => {
            this.events = shot2docs(res);
        });
    },
};
</script>
